import {Portal_Type,Portal_Title} from "biz9-portal-app";
const Config = {
    TITLE:'500-Service',

    //* -- dev
    /*
    APP_ID:'500-STAGE',
    APP_ENV:Portal_Type.ENV_TEST,
    HOST:"http://localhost:1901",
    //IMAGE_HOST:"http://localhost:1901/uploads",
    //IMAGE_HOST:"http://stage_portal.bossappz.com/uploads",
    IMAGE_HOST:"https://storage.googleapis.com/bossappz",
    SYSTEM_1_APP_ID:'500-STAGE',
    PORT_ID:"1901",
    */

    //* -- stage-1
    /*
    APP_ID:'500-PROD-2',
    APP_ENV:Portal_Type.ENV_TEST,
    HOST:"http://localhost:1901",
    IMAGE_HOST:"https://storage.googleapis.com/bossappz",
    SYSTEM_1_APP_ID:'500-PROD-2',
    PORT_ID:"1901",
    */


    //* -- stage-2
    /*
    APP_ID:'500-STAGE',
    APP_ENV:Portal_Type.ENV_STAGE,
    HOST:"http://stage_portal.bossappz.com",
    IMAGE_HOST:"http://stage_portal.bossappz.com/uploads",
    SYSTEM_1_APP_ID:'500-STAGE',
    PORT_ID:"1901",
    */
    //

    //* -- prod
    APP_ID:'500-PROD',
    APP_ENV:Portal_Type.ENV_PRODUCTION,
    HOST:"https://portal.bossappz.com",
    IMAGE_HOST:"https://storage.googleapis.com/bossappz",
    SYSTEM_1_APP_ID:'500-PROD',
    PORT_ID:"1902",
    //

    CACHE_TIME_LIMIT:'1',
    URL_USER_NO_IMAGE:"/assets/img/user/ceo.png",
    URL_PRODUCT_NO_IMAGE:"/assets/img/app/mobile.png",
    URL_CART_NO_IMAGE:"/assets/img/cart/cart.png",
    SUPER_ADMIN_ID:"0a8f3913-cecc-43eb-8a76-31ab8cd3ee21",
    SYSTEM_1_ID:"1",
    SYSTEM_1_TITLE:"System 1",
    SYSTEM_1_URL:"http://localhost:3000",
    SYSTEM_1_SERVICE_URL:"http://localhost:1904",
    STRIPE_KEY:"pk_test_51RkvILBLx49RFzHwsuuMA064DQbmaMqtmt72UB9VGrWnWdhmPFhyiopqyYa2ETmezsim4EX0LCcDC71Hz16n7grI00KKCMww2R",
    STRIPE_SECRET_KEY:"sk_test_51RkvILBLx49RFzHwqq12TwN0zYMBUbQEbmpVsNapnyIlkgtLL4TUCKSqI6lTx4IGdHRxggScXRyg9pzZu8tJPxEQ00s7YEtaQt"
}

const CMS_Config = {
    ITEMS_TITLE_COUNT:50
}
const Data_Config = {
    APP_ID:Config.APP_ID,
    MONGO_IP:'0.0.0.0',
    MONGO_USERNAME_PASSWORD:'',
    MONGO_PORT_ID:"27019",
    MONGO_SERVER_USER:'admin',
    MONGO_CONFIG_FILE_PATH:'/etc/mongod.conf',
    MONGO_SSH_KEY:"",
    REDIS_URL:"0.0.0.0",
    REDIS_PORT_ID:"27019"
};
class Project_Table {
    static APP = "app_biz";
    static LINK = "link_biz";
}
class Type {
    // -- source --
    static SOURCE_SERVER = "server";
    static SOURCE_CACHE = "cache";
    // -- cms --
    static URL = "url";

    // --- paging ---
    static PAGE_CURRENT = 1;
    static PAGE_SIZE = 40;
    static TABLE_DEFAULT_SIZE = 40;
    static OPTION = {};
    // --- dashboard ---
    static DASHBOARD_USER = "type_dashboard_user";
    static DASHBOARD_APP = "type_dashboard_app";
    // -- app-type --
    //static APP_MOBILE="Mobile";
    //static APP_WEBSITE="Website";
    //static APP_LANDING="Landing";
    // -- cache --
    static KEY_CACHE_PAGE = "key_cache_page";
    static KEY_CACHE_TEMPLATE = "key_cache_template";
    // -- storage --
    static KEY_STORAGE_USER = "key_storage_user";
    static KEY_STORAGE_USER_CART = "key_storage_user_cart";
    static KEY_STORAGE_USER_ORDER = "key_storage_user_order";
    static KEY_STORAGE_SUB_VALUE = "key_storage_sub_value"; // --delete
    static KEY_STORAGE_SUB_VALUE_GROUP = "key_storage_sub_value_group";
    static KEY_STORAGE_FAVORITES = "key_storage_favorites";
    // - storage - dashboard
    static KEY_STORAGE_DASHBOARD = "key_storage_dashboard";
    static KEY_STORAGE_DASHBOARD_SIDE_BAR = "key_storage_dashboard_side_bar";
    static KEY_STORAGE_DASHBOARD_SUB_MENU_CURRENT_ITEM_DATA = "key_storage_dashboard_sub_menu_current_item_data";
    static KEY_STORAGE_DASHBOARD_SUB_MENU_CURRENT_ITEM_ID = "key_storage_dashboard_sub_menu_current_item_id";
    static KEY_STORAGE_DASHBOARD_APPS = "key_storage_dashboard_apps";
    static KEY_STORAGE_DASHBOARD_APP = "key_storage_dashboard_app";
    static KEY_STORAGE_DASHBOARD_URL = "key_storage_dashboard_url";
    static KEY_STORAGE_DASHBOARD_FIELD_VALUE_PAGE = "key_storage_dashboard_field_value_page";
    static KEY_STORAGE_DASHBOARD_ITEM_GROUPS = "key_storage_dashboard_item_groups";
    // --  basket-order-cart --
    static PAYMENT_PLAN_TYPE = 'payment_plan_type';
    static PAY_NOW_COST = 'pay_now_cost';
    static APP_TYPE = 'app_type';
    static APP_CATEGORY = 'app_category';
    static ORDER_NUMBER = 'order_number';
    // -- PORTAL-TYPE-START -- //
    // -- base --
    static CATEGORY = 'category';
    static CATEGORYS = 'categorys';
    static CATEGORY_IMAGE = 'category_image';
    static REVIEWS = 'reviews';
    // --- base-product-app-image-gallerys-images ---
    static IMAGE_GALLERY_DETAIL_IMAGES = 'detail_images';
    static IMAGE_GALLERY_INFO_IMAGES = 'info_images';
    static IMAGE_GALLERY_MAIN_IMAGES = 'main_images';
    // -- project --
    static DELIVERY_TIME = 'delivery_time';
    static PARTNERS = 'partners';
    static TEMPLATE_PRIMARY = 'primary';
    // -- product-types --
    // -- product-app --
    static PRODUCT_APP = "product_app";
    // -- product-subs --
    static PRODUCT_SUB_TYPE_HOSTING_TYPES = 'product_sub_type_hosting_types';
    static PRODUCT_SUB_TYPE_HOSTING_DURATIONS = 'product_sub_type_hosting_durations';
    static PRODUCT_SUB_TYPE_CONTENT_MANAGEMENT_SYSTEMS = 'product_sub_type_content_management_systems';
    static PRODUCT_SUB_TYPE_SPEC_WEEKLY_HOURS = 'product_sub_type_spec_weekly_hours';
    static PRODUCT_SUB_TYPE_SPEC_WEEKLY_HOUR = 'product_sub_type_spec_weekly_hour';
    // --  page-home --
    // --- page-home-products ---
    static PRODUCTS_POPULAR = "products_popular";
    static PRODUCTS_LATEST = "products_latest";
    static PRODUCTS_TRENDING = 'products_trending';
    static PRODUCTS_TOP = 'products_top';
    // --- page-home-category-products ---
    static CATEGORY_1_PRODUCTS_TITLE = 'category_1_products_title';
    static CATEGORY_2_PRODUCTS_TITLE = 'category_2_products_title';
    static CATEGORY_3_PRODUCTS_TITLE = 'category_3_products_title';
    static CATEGORY_4_PRODUCTS_TITLE = 'category_4_products_title';
    static CATEGORY_5_PRODUCTS_TITLE = 'category_5_products_title';
    static CATEGORY_6_PRODUCTS_TITLE = 'category_6_products_title';
    static CATEGORY_7_PRODUCTS_TITLE = 'category_7_products_title';
    static CATEGORY_1_PRODUCTS = 'category_1_products';
    static CATEGORY_2_PRODUCTS = 'category_2_products';
    static CATEGORY_3_PRODUCTS = 'category_3_products';
    static CATEGORY_4_PRODUCTS = 'category_4_products';
    static CATEGORY_5_PRODUCTS = 'category_5_products';
    static CATEGORY_6_PRODUCTS = 'category_6_products';
    static CATEGORY_7_PRODUCTS = 'category_7_products';
    // ---  page-home-products-explore ---
    static PRODUCTS_EXPLORE_1 = 'products_explore_1';
    static PRODUCTS_EXPLORE_2 = 'products_explore_2';
    static PRODUCTS_EXPLORE_3 = 'products_explore_3';
    static PRODUCTS_EXPLORE_4 = 'products_explore_4';
    // -- gallerys --
    static GALLERY_ADMIN_PANELS = 'gallery_admin_panels';
    static GALLERY_CONTENT_MANAGMENT_SYSTEMS = 'content_managment_systems';
    static GALLERY_HOSTINGS = 'gallery_hostings';
    static GALLERY_LANDING_PAGES = 'gallery_landing_pages';
    static GALLERY_MOBILES = 'gallery_mobiles';
    static GALLERY_WEBSITES = 'gallery_websites';
    // -- PORTAL-TYPE-END --

    // -- other --
    static STATUS_TYPE = 'status_type';
    static USER_STATUS_TYPE = 'user_status_type';


   }
class Field {
    static AUTHOR = "author";
    static APP_PRODUCT = "app_product";
    static APP_ID = "app_id";
    static ANY = 'any';
    static APP_DETAIL = "app_detail";
    static APP_LINK = "app_link";
    static CATEGORY = "category";
    static CATEGORY_TYPE = "category_type";
    static DATE = 'date';
    static DESCRIPTION = 'description';
    static EDIT_LOCATION = 'edit_location';
    static FIELD = 'field';
    static FIELD_TITLE = 'field_title';
    static GROUP = 'group';
    static GROUP_ID = 'group_id';
    static HOSTING_PRODUCT = 'hosting_product';
    static HEADER = 'header';
    static KEYWORD = 'keyword';
    static LINK = "link";
    static LOCATION = "location";
    static MEETING_LINK = 'meeting_link';
    static MESSAGE = 'message';
    static NOTE = 'note';
    static PARAM = 'param';
    static PAGE = 'page';
    static PRODUCT_COUNT = 'product_count';
    static PRODUCT_ID = 'product_id';
    static HOSTING_ID = 'hosting_id';
    static CMS_ID = 'cms_id';
    static SUB_VALUES = 'sub_values';
    static SETTING_DELETE_PROTECTION = 'setting_delete_protection';
    static SETTING_VISIBLE = 'setting_visible';
    static STATUS_TYPE = 'status_type';
    static TAG = 'tag';
    static TEMPLATE_PRODUCT = 'template_product';
    static TEMPLATE_PRODUCTS = 'template_products';
    static TEMP_ID = "temp_id";
    static TIME = "time";
    static TITLE = "title";
    static TYPE = 'type';
    static TYPES = 'types';
    static URL = 'url';
    static USER_STATUS_TYPE = 'user_status_type';
    static VALUE = "value";
    static WEBSITE = 'website';
}
class Url {
    //-- dashboard --
    static DASHBOARD_NO_IMAGE="/images/no_img.jpg";
    static DASHBOARD_USER="/dashboard/user/home";
    static DASHBOARD_APP="/dashboard/app/home";
    // -- page --
    static PAGE_ABOUT="page/about";

    static FILE_CDN_POST="main/file/cdn_post";
    // -- public --
    static APP_DETAIL="/app/";
    static PUBLIC_NO_IMAGE="/images/no_img.jpg";
    // -- team --
    static TEAM="/team/";
    // -- cart --
    static CMS_SEARCH_ITEM_TYPE_CATEGORY="cms/search_item_type_category";
    // -- cms --
    static FIELD_VALUE_POST="item/field_value_post";
}
class Title {
    static APP_ID = "APP-";
    static BLOG_POST = 'Blog Post';
    static CATEGORY = 'Category';
    static CONTENT = 'Content';
    static CUSTOM_FIELD = 'Custom_Field';
    static EVENT = 'Event';
    static FAQ = 'Faq';
    static GALLERY = 'Gallery';
    static PAGE = 'Page';
    static USER = 'User';
    static TYPE = 'Type';
    static TEMPLATE = 'Template';
    static SERVICE = 'Service';
    static SUB_VALUE = 'Sub Value';
    static STAT = 'Stat';
    // -- user-sidebar --
    static USER_SIDE_BAR_APPZ = "AppZ";
    static USER_SIDE_BAR_BLOG_POST = "Blog Posts";
    static USER_SIDE_BAR_CATEGORY = "Categorys";
    static USER_SIDE_BAR_CART = "CartZ";
    static USER_SIDE_BAR_CONTENT = "Content";
    static USER_SIDE_BAR_CUSTOM_FIELD = "Fields";
    static USER_SIDE_BAR_DASHBOARD = "Dashboard";
    static USER_SIDE_BAR_DEMO = "demo";
    static USER_SIDE_BAR_EVENT = "Events";
    static USER_SIDE_BAR_FAQ = "Faqs";
    static USER_SIDE_BAR_FAVORITE = "FavoriteZ";
    static USER_SIDE_BAR_GALLERY = "GalleryZ";
    static USER_SIDE_BAR_ORDER = "OrderZ";
    static USER_SIDE_BAR_PAGE = "PageZ";
    static USER_SIDE_BAR_PRODUCT = "ProductZ";
    static USER_SIDE_BAR_REVIEW = "ReviewZ";
    static USER_SIDE_BAR_SERVICE = "ServiceZ";
    static USER_SIDE_BAR_STAT = "StatZ";
    static USER_SIDE_BAR_TEMPLATE = "TemplateZ";
    static USER_SIDE_BAR_TYPE = "TypeZ";
    static USER_SIDE_BAR_USER = "UserZ";
    static TEMPLATE_PRIMARY = 'Primary';
    // -- label --
    static LABEL_AUDIO = 'Audio';
    static LABEL_ADD = 'Add';
    static LABEL_ANY = 'Any';
    static LABEL_COPY = 'Copy';
    static LABEL_CLOSE = 'Close';
    static LABEL_DELETE = 'Delete';
    static LABEL_EDIT = 'Edit';
    static LABEL_NEWZ_UPDATEZ = 'NewZ and UpdateZ';
    static LABEL_CMS_TAB_AUDIO = 'Audio';
    static LABEL_CMS_TAB_CUSTOM_FIELD = 'Fields';
    static LABEL_CMS_TAB_GENERAL = 'General';
    static LABEL_CMS_TAB_GROUP = 'Groups';
    static LABEL_CMS_TAB_IMAGE_GALLERY = 'Image Galleries';
    static LABEL_CMS_TAB_IMAGE_GALLERY_IMAGE = 'Gallery Images';
    static LABEL_CMS_TAB_NOTE = 'Note';
    static LABEL_CMS_TAB_IMAGE = 'Images';
    static LABEL_CMS_TAB_SETTING = 'Settings';
    static LABEL_CMS_TAB_VALUE = 'Values';
    static LABEL_ID = 'Id';
    static LABEL_GO_BACK = 'Go Back';
    static LABEL_KEY = 'Key';
    static LABEL_NO_DATA = 'No Data';
    static LABEL_SAVE = 'Save';
    static LABEL_SEARCH = 'Search';
    static LABEL_PREVIEW = 'Preview';
    static LABEL_SETTING = 'Settings';
    static LABEL_STATUS_TYPE = 'Status';
    static LABEL_SYSTEM_STATUS_TYPE = 'System Status';
    static LABEL_USER_STATUS_TYPE = 'User Status';
    static LABEL_TITLE = 'Title';
    static LABEL_TYPE = 'Type';
    static LABEL_UPLOAD = 'Upload';
    static LABEL_VALUE = 'Values';
    static LABEL_DETAILS = 'Details';
    static LABEL_APP = 'App';
    static LABEL_PROFILE = 'Profile';
    // -- menu --
    static LABEL_MENU_HOME = 'Home';
    static LABEL_MENU_ABOUT = 'About';
    static LABEL_MENU_APPZ = 'AppZ';
    static LABEL_MENU_BLOG = 'NewZ';
    static LABEL_MENU_FAQ = 'FAQs';
    static LABEL_MENU_PORTOFOLIO = 'Portofolio';
    static LABEL_MENU_TEAM = 'Team';
    static LABEL_MENU_REVIEW = 'Reviews';
    // -- home --
    static LABEL_VIEWS = 'Views';
    // -- cms --
    static LABEL_LAST_LOGIN = 'Last Login';
    static LABEL_LOGOUT = 'Log Out';
    static LABEL_SELECT = 'Select';
    // -- cms-page-titlez --
    static LABEL_CMS_PAGE_TITLE_DASHBOARD = 'Dashboard';
    static LABEL_CMS_PAGE_TITLE_ADMIN_APPZ = 'AppZ';
    static LABEL_CMS_PAGE_TITLE_ADMIN_CARTZ = 'CartZ';
    static LABEL_CMS_PAGE_TITLE_ADMIN_FAVORITEZ = 'FavoriteZ';
    static LABEL_CMS_PAGE_TITLE_ADMIN_ORDERZ = 'OrderZ';
    // -- cms-user-order-detail --
    static LABEL_ORDER_DETAILS = 'Order Details';
    static LABEL_GRAND_TOTAL = 'Grand Total';
    static LABEL_ORDER_NUMBER = 'Order Number';
    static LABEL_PAYMENT_PLAN = 'Payment Plan';
    static LABEL_STATUS = 'Status';
    static LABEL_ORDER_PAYMENTS = 'Order Payments';
    static LABEL_ADD = 'Add';
    static LABEL_ORDER_ITEMS = 'Order Items';
    static LABEL_ORDER_SUB_ITEMS = 'Order Sub Items';
    static LABEL_AMOUNT = 'Amount';
    static LABEL_MAKE_PAYMENT = 'Make Payment';
    static LABEL_CHOOSE_AN_AMOUNT = 'Choose an Amount';
    static LABEL_USER_SELECT_PAYMENT_AMOUNT = 'Select A User Status';
    static LABEL_USER_SELECT_STATUS = 'Select User Status';
    static LABEL_ORDER_USER_STATUS = 'Order User Status';
    // -- cms-user-app-detail --
    static LABEL_USER_STATUS = 'User Status';

    // -- app --
    static LABEL_HOSTING = 'Hosting';
    static LABEL_LINKS = 'Links';
    static LABEL_REVIEWS = 'Reviews';
    static LABEL_ADDED_ON = 'Added On';
    static LABEL_PAY_NOW = 'Pay Now';
    static LABEL_REVIEWS_AND_RATINGS = 'Reviews & Ratings';
    static LABEL_LEAVE_A_REVIEW = 'Leave A Review';
    static LABEL_LOGIN_TO_ADD_REVIEW = 'Please login to add a review.';
    static LABEL_BUY_THIS_APPLICATION = 'Buy This Application';
    static LABEL_IMAGES = 'IMAGES';
    static LABEL_SCREENSHOTS = 'SCREENSHOTS';
    static LABEL_DEMO = 'DEMO';
    static LABEL_VIDEO = 'VIDEO';
    static LABEL_ANDROID = 'ANDROID';
    static LABEL_IOS = 'IOS';
    static LABEL_REFERENCE = 'REFERENCE';
    static LABEL_TOTAL_VIEWS = 'Total Views';
    static LABEL_DELIVERY_TIME = 'Delivery Time';
    static LABEL_APP_TYPE = 'App Type';
    static LABEL_PRICE = 'Price';
    static LABEL_PAY_NOW = 'Pay Now';
    static LABEL_GRAND_TOTAL = 'Grand Total';
    // -- app-check-out --
    static LABEL_BILLING_DETAILS = 'Billing Details';
    static LABEL_LOGIN_CHECKOUT = 'Login To Checkout';
    // -- app search
    static LABEL_APPLICATION_TYPE = 'Application Type';
    // -- app-status-type --
    static APP_STATUS_TYPE_DEVELOPMENT = 'Development';
    static APP_STATUS_TYPE_NEW = 'New';
    static APP_STATUS_TYPE_NOT_AVAILBLE = 'Not Availble';
    static APP_STATUS_TYPE_BALANCE_DUE = 'Balance Due';
    static APP_STATUS_TYPE_PRODUCTION = 'Production';
    static APP_STATUS_TYPE_PLANNED_DOWNTIME = 'Planned Downtime';
    static APP_STATUS_TYPE_REMOVED = 'Removed';
    static APP_STATUS_TYPE_STAGING = 'Staging';
    // -- app-user-status-type --
    static APP_USER_STATUS_TYPE_NOT_AVAILBLE = 'Not Availble';
    static APP_USER_STATUS_TYPE_PRODUCTION = 'Production';
    static APP_USER_STATUS_TYPE_PLANNED_DOWNTIME = 'Planned Downtime';
    static APP_USER_STATUS_TYPE_PENDING = 'Pending';
    // -- user-account-status --
    static USER_ACCOUNT_STATUS_TYPE_ACTIVE = 'Active';
    static USER_ACCOUNT_STATUS_TYPE_PENDING = 'Pending';
    static USER_ACCOUNT_STATUS_TYPE_SUSPENDED = 'Suspended';
    static USER_ACCOUNT_STATUS_TYPE_CLOSED = 'Closed';

    // -- PORTAL-TITLE-START -- //
    static PRODUCT = 'Product';
    // -- product-app --
    static PRODUCT_APP_TYPE_CONTENT_MANAGEMENT_SYTSTEM = 'Content Management System';
    static PRODUCT_APP_TYPE_HOSTING = 'Hosting';
    static PRODUCT_APP_TYPE_LANDING_PAGE = 'Landing Page';
    static PRODUCT_APP_TYPE_MOBILE = 'Mobile';
    static PRODUCT_APP_TYPE_WEBSITE = 'Website';
    static PRODUCT_APP_TYPE_SPECIALIST = 'Specialist';
    // -- product-sub --
    // --- hosting ---
    static PRODUCT_SUB_TYPE_HOSTING = 'Hosting';
    static PRODUCT_SUB_TYPE_HOSTING_CATEGORY_TYPE = 'Type';
    static PRODUCT_SUB_TYPE_HOSTING_CATEGORY_DURATION = 'Duration';
    // -- content-management-system --
    static PRODUCT_SUB_TYPE_ADMIN_DASHBOARD = 'Admin Dashboard';
    // -- specialist --
    static PRODUCT_SUB_TYPE_SPEC_WEEKLY_HOUR = 'Specialist';
    static PRODUCT_SUB_TYPE_SPEC_WEEKLY_HOUR_CATEGORY = 'Content Specialist Weekly Hour';
    // -- product-apps --
    static PRODUCT_APP_TYPES = [
        Title.PRODUCT_APP_TYPE_CONTENT_MANAGEMENT_SYTSTEM,
        Title.PRODUCT_APP_TYPE_HOSTING,
        Title.PRODUCT_APP_TYPE_LANDING_PAGE,
        Title.PRODUCT_APP_TYPE_MOBILE,
        Title.PRODUCT_APP_TYPE_WEBSITE,
    ];
    static PRODUCT_APP_CATEGORYS = ['Beauty','Church','Fashion','Food Trucks','Health Care','Music','Pets','Services','Service Repair','Sports','Transportation'];
    static PRODUCT_SPECIALIST_CATEGORYS = ['Weekly Hour'];
    static APPLICATION_DEVELOPMENT = 'Application Development';
    // -- PORTAL-TITLE-END -- //




}
class Message {
    //toast - start
    static DELETING = 'Deleting...';
    static ERROR = 'Error';
    static LOADING = '...Loading';
    static LOGIN = 'Please Login.';
    static LOGGING_IN = 'Logging In...';

    static EMAIL_BAD = 'Email Bad';
    static USERNAME_BAD = 'UserName Bad';
    static PASSWORD_BAD = 'Password Bad';

    static DELETED = 'Successfully Deleted';
    static INPUT_REQUIRED = 'Input Is Required';
    static SEARCHING = 'Searching...';
    static SAVING = 'Saving...';
    static REGISTERING = 'Registering...';
    static USER_PASSWORD_NEW_CONFIRM_BAD="The New and Confirm Password Dont Match.";
    static USER_EMAIL_NEW_CONFIRM_BAD="The New and Confirm Email Dont Match.";

    static CONFIRM="Are You Sure?";
    static ITEM_TITLE_BAD="Please Enter A Valid Title.";
    static DATA_NOT_FOUND="Data Not Found.";
    static SYSTEM_NOT_FOUND="System Not Found.";

    static PROCCESSING_PAYMENT="Proccessing Payment.";
}
export {
    CMS_Config,
    Config,
    Data_Config,
    Field,
    Message,
    Project_Table,
    Title,
    Type,
    Url
};
